import React, { useState, useEffect, useContext, useMemo } from "react";

import { AppContext } from "../../../App";

import { Grade, GradeOpcoes, PageControl, TabSheet, InputText } from "../../../components";
import { Button, Grid } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import { AppOptionsContext } from "../../../components/main/main";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import TablePagination from "../../../components/grade/TablePagination";
import ApiTypes from "../../../api/system/types/ApiTypes";
import QueryOrdersTypes from "../query/ordersTypes";
import OperationsNatureUtils from "./utils";
import ApiOperationsNature from "../../../api/basics/operationsNature";
import OperationsNatureChange from "./change";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const initialCondition = {
    id: "",
    name: "",
    order_type: {},
    inactivate: false,
};

export default function OperationsNature() {
    const queryParams = useParams();

    const { setLoading, showMessageError } = useContext(AppContext);
    const { setOptions, setTitle } = useContext(AppOptionsContext);

    const [tabIndex, setTabIndex] = useState(0);
    const [dataSource, setDataSource] = useState([]);

    const [rowCount, setRowCount] = useState(0);
    const [rowPage, setRowPage] = useState(10);
    const [page, setPage] = useState(0);

    const [condition, setCondition] = useState(initialCondition);
    const [conditionApply, setConditionApply] = useState(initialCondition);

    const [idInEdition, setIdInEdition] = useState(0);

    const [typesOperationsNature, setTypesOperationsNature] = useState([]);

    const metaData = useMemo(() => [
        {
            label: "Opções",
            render: (record) => {
                const options = [
                    { tipo: "edit", label: "Edição" },
                    { tipo: "inactive", label: "Inativação" },
                ];

                return (
                    <span>
                        <GradeOpcoes record={record} onClickOpcoes={onClickOptions} opcoes={options} />
                    </span>
                );
            },
        },
        { label: "Código", field: "id", align: "right" },
        { label: "Nome", field: "name" },
        {
            label: "Posse/Propriedade",
            render: (record) => {
                return <span> {OperationsNatureUtils().typeStocksKeeperText(record.stock_keeper) || "Sem Controle de Estoque"} </span>;
            },
        },
        {
            label: "Regra Item",
            render: (record) => {
                return <span> {OperationsNatureUtils().typeIssuerItemText(record.type_issuer_item) || "Item sem Regra"} </span>;
            },
        },
        { label: "Dh.Criação", field: "created_at", format: "datetime", minWidth: 160 },
        { label: "Dh.Atualização", field: "updated_at", format: "datetime", minWidth: 160 },
    ]);

    useEffect(() => {
        setTitle(`Naturezas de Operação ${queryParams.operation_type === "in" ? "Entradas" : "Saídas"}`);
        loadDataSource(0);

        // Types
        ApiTypes()
            .apiDefault.findAll({ entity_in: "operations_nature" })
            .then((rec) => {
                setTypesOperationsNature(rec.data);
            });

        return () => {
            setOptions(null);
        };
    }, []);

    useEffect(() => {
        setTitle(`Naturezas de Operação ${queryParams.operation_type === "in" ? "Entradas" : "Saídas"}`);
        loadDataSource(0);
    }, [queryParams.operation_type]);

    const loadDataSource = async (newPage, newRowPage, newCondition) => {
        setLoading(true);

        // Condition
        const conditionCustom = makeCondition(newCondition || conditionApply);

        try {
            const result = await ApiOperationsNature().apiDefault.find({
                page: newPage + 1,
                pageSize: newRowPage || rowPage,
                condition: conditionCustom,
                associates: ["order_type"],
            });

            if (result.status) {
                setDataSource(result.data);
                setRowCount(result.info.total);
            } else {
                setDataSource([]);
                if (result.message) {
                    showMessageError(result.message);
                }
            }
        } catch (e) {
            showMessageError(e.message);
        } finally {
            setLoading(false);
        }
    };

    const makeCondition = (newCondition) => {
        const result = {
            operation_type: queryParams.operation_type,
        };

        // Name
        if (newCondition.id) {
            result.id_like = encodeURIComponent(newCondition.id + "+");
        }


        // Name
        if (newCondition.name) {
            result.name_like = encodeURIComponent(newCondition.name + "+");
        }

        // Type Operation
        if (newCondition.order_type?.id) {
            result.order_type_id = newCondition.order_type?.id;
        }

        if (!newCondition.inactivate) {
            result.inactivate_at_is_null = true;
        }

        return result;
    };

    const onClickOptions = (record, tipo) => {
        switch (tipo) {
            case "edit":
                setIdInEdition(record.id);
                break;
            case "inactive":
                break;
            default:
                break;
        }
    };

    const onFinalize = async (updated) => {
        setTabIndex(0);
        setIdInEdition(0);

        if (updated) {
            loadDataSource(page);
        }
    };

    useEffect(() => {
        if (tabIndex === 0) {
            setOptions(
                <>
                    <TablePagination
                        rowCount={rowCount}
                        rowPage={rowPage}
                        page={page}
                        onPageChange={(event, newPage) => {
                            loadDataSource(newPage);
                            setPage(newPage);
                        }}
                        onRowsPerPageChange={(event) => {
                            loadDataSource(0, event.target.value);
                            setPage(0);
                            setRowPage(event.target.value);
                        }}
                    />
                </>
            );
        }
    }, [tabIndex, rowCount, rowPage, page]);

    return (
        <>
            <PageControl tabindex={tabIndex} onchangetab={(index) => setTabIndex(index)}>
                <TabSheet label="Consulta">
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={2}>
                            <InputText
                                label="Código"
                                size="small"
                                autoFocus
                                fullWidth
                                variant="outlined"
                                value={condition.id}
                                onChangeValue={(e) => setCondition({ ...condition, id: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputText
                                label="Nome ou parte do nome da natureza de operação"
                                size="small"
                                autoFocus
                                fullWidth
                                variant="outlined"
                                value={condition.name}
                                onChangeValue={(e) => setCondition({ ...condition, name: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <QueryOrdersTypes
                                type_operation={queryParams.operation_type}
                                title="Consulta Tipos de Ordens"
                                label="Tipo de Ordem"
                                value={condition.order_type}
                                onChangeValue={(data) => setCondition({ ...condition, order_type: data })}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Button
                                style={{ float: "right", marginTop: "5px", marginBottom: "5px", marginRight: "5px" }}
                                variant="contained"
                                size="small"
                                type="primary"
                                onClick={() => {
                                    loadDataSource(0, rowPage, condition);
                                    setConditionApply(condition);
                                }}
                                startIcon={<SearchIcon fontSize="inherit" />}
                            >
                                Pesquisar
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grade dataSource={dataSource} metaData={metaData} disablepagination />
                    </Grid>
                </TabSheet>
                <TabSheet label={idInEdition ? `Tipo de Ordem ${idInEdition}` : null} icon={idInEdition ? null : <AddCircleIcon />}>
                    <Grid container spacing={1}>
                        <OperationsNatureChange
                            id={idInEdition}
                            operation_type={queryParams.operation_type}
                            onLoadRecord={() => setTabIndex(1)}
                            onFinalize={(updated) => onFinalize(updated)}
                            showOptions={tabIndex === 1}
                            types={typesOperationsNature}
                        />
                    </Grid>
                </TabSheet>
            </PageControl>
        </>
    );
}
